/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    resetToInitialState(state) {
      state.isLoading = false;
    },

    setIsLoadingState(state, { payload }) {
      state.isLoading = payload;
    },
  },
});

export const { resetToInitialState, setIsLoadingState } = headerSlice.actions;

export const setIsLoading =
  (payload: any = () => {}) =>
  (dispatch: any) => {
    dispatch(setIsLoadingState(payload));
  };

export default headerSlice.reducer;
